import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { frequencyTranslationLookup, getPaymentFrequencyOptionsArray } from "src/store/selectors/financeSettings";
import { getSelectedFrequency } from "src/store/selectors/vehicles";
import CellText from "src/components/MyGarage/TableCompare/Cells/CellText";
import CellDropdown from "src/components/MyGarage/TableCompare/Cells/CellDropdown";
import { patchPaymentsRequest } from "src/store/actions/payments";

interface Props {
    vin: string;
    paymentType: "cash" | "loan" | "lease";
}

const PaymentFrequencyCell = ({
    vin,
    uuid,
    paymentType,
    frequency,
    frequencyOptions,
    patchPayments,
}: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { t } = useTranslation();

    const handleChange = (_vin: string, _key: string, value: string) => {
        patchPayments(
            uuid,
            vin,
            {
                [paymentType]: {
                    frequency: value,
                },
            },
            "patch_payment_frequency"
        );
    };

    if (frequencyOptions.length > 1) {
        return (
            <CellDropdown
                vin={vin}
                title={t("MyGarage.TableCompare.frequency")}
                options={{
                    [paymentType]: frequencyOptions,
                }}
                paymentType={paymentType}
                selected={frequency}
                dataKey={`payments|${paymentType}|frequency`}
                onUpdate={handleChange}
            />
        );
    }

    return <CellText title={t("MyGarage.TableCompare.frequency")} value={frequencyTranslationLookup(frequency)} />;
};

const mapStateToProps = (state: ApplicationStore, { vin, paymentType }: Props) => {
    return {
        uuid: state.deal.uuid!,
        frequency: getSelectedFrequency(state, vin, paymentType),
        frequencyOptions: getPaymentFrequencyOptionsArray(state, vin, paymentType),
    };
};

const mapDispatchToProps = {
    patchPayments: patchPaymentsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentFrequencyCell);
